import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

const experience = [
  {
    duration: 'Jul 2022 - Mar 2025',
    jobTitle: 'C# Developer | Full Stack Developer, ',
    companyName: '3XPO - Sydney',
    responsibilities: [
      'Develop and optimise C# scripts for mobile applications, ensuring high performance and seamless user experiences.',
      'Developed and optimised web applications using Flutter, React, JavaScript, and TypeScript, leveraging JSInterop for seamless integration with other technologies while ensuring scalability and responsiveness.',
      'Implemented OAuth 2.0 authentication for secure user access, enabling seamless third-party logins.',
      'Developed and maintained a custom Flutter plugin for third-party integrations, including the Zoom Meeting SDK, ensuring seamless connectivity and enhanced functionality.',
      'Utilised AWS S3 for cloud storage and EC2 for hosting scalable backend services.',
      'Manage and track project progress using JIRA, ensuring timely delivery of features and resolving issues efficiently.',
      'Participated in technical discussions and collaborated with stakeholders to determine requirements and implement solutions.',
      'Streamlined deployment processes by implementing CI/CD pipelines with GitLab, accelerating release cycles.',
    ],
    skills: ['C#', 'Flutter', 'React', 'JavaScript', 'TypeScript', 'WordPress', 'AWS', 'JIRA', 'Unity 3D'],
  },
  {
    duration: 'Jul 2020 - Apr 2022',
    jobTitle: 'Full Stack .NET Developer, ',
    companyName: 'Crystal Solution Pvt. Ltd. - Nepal',
    responsibilities: [
      'Designed and developed ERP web applications using ASP.NET Core, Entity Framework, and MySQL, enabling seamless business operations.',
      'Built and maintained RESTful APIs, facilitating robust system integrations with mobile and web platforms.',
      'Implemented Entity Framework for efficient data access, enabling faster development and simplifying database interactions.',
      'Conducted unit and integration testing using xUnit, ensuring high code reliability.',
      'Collaborated in an Agile development environment, participating in sprints, code reviews, and daily stand-ups.',
      'Utilised tools like Git for version control to ensure efficient project delivery.',
    ],
    skills: ['ASP.NET Core', 'Entity Framework', 'MySQL', 'RESTful APIs', 'NUnit', 'Agile', 'Git'],
  },
];

export default function ExperiencePage() {
  return (
    <Box id="experience" sx={{ mb: 8 }}>
      <Typography
        sx={{
          fontFamily: '"Space Grotesk", sans-serif',
          color: '#EDEFF7',
          fontSize: '22px',
          fontWeight: 600,
          mb: 4,
        }}
      >
        Experience
      </Typography>
      <Stack direction="column">
        {experience.map((job, i) => (
          <Box key={i} sx={{ display: 'flex', gap: '24px', position: 'relative', pb: '36px' }}>
            {/* Connecting line: absolutely positioned so it bridges precisely to the next dot center */}
            {i < experience.length - 1 && (
              <Box
                sx={{
                  position: 'absolute',
                  left: '7px',
                  top: '22px',   // 6px dot margin-top + 10px dot height + 6px gap
                  bottom: '-11px', // 11px below entry bottom edge = center of next dot
                  width: '1px',
                  bgcolor: 'rgba(111,243,232,0.18)',
                }}
              />
            )}
            {/* Timeline dot + line */}
            <Box sx={{ flex: '0 0 14px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  bgcolor: '#6FF3E8',
                  mt: '6px',
                  flexShrink: 0,
                  position: 'relative',
                  zIndex: 1,
                }}
              />
              <Box sx={{ flex: 1, width: '1px', bgcolor: 'rgba(111,243,232,0.18)', mt: '6px' }} />
            </Box>
            {/* Entry content */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                sx={{
                  color: '#7B8AC0',
                  fontSize: '13px',
                  fontFamily: '"Space Grotesk", sans-serif',
                  letterSpacing: '0.03em',
                }}
              >
                {job.duration}
              </Typography>
              <Box sx={{ mt: '6px', mb: '14px' }}>
                <Typography
                  component="span"
                  sx={{ color: '#6FF3E8', fontSize: '17px', fontWeight: 500, fontFamily: '"Space Grotesk", sans-serif' }}
                >
                  {job.jobTitle}
                </Typography>
                <Typography component="span" sx={{ color: '#EDEFF7', fontSize: '17px' }}>
                  {job.companyName}
                </Typography>
              </Box>
              <Stack direction="column" gap="6px">
                {job.responsibilities.map((r, j) => (
                  <Box key={j} sx={{ color: '#A8BEF0', fontSize: '14.5px', lineHeight: 1.6, display: 'flex', gap: '8px' }}>
                    <Box component="span" sx={{ color: '#6FF3E8', flexShrink: 0 }}>→</Box>
                    {r}
                  </Box>
                ))}
              </Stack>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px', mt: '14px' }}>
                {job.skills.map(s => (
                  <Box
                    key={s}
                    component="span"
                    sx={{
                      bgcolor: '#131A45',
                      color: '#6FF3E8',
                      fontSize: '12px',
                      fontWeight: 500,
                      px: '10px',
                      py: '4px',
                      borderRadius: '5px',
                      fontFamily: '"Space Grotesk", sans-serif',
                    }}
                  >
                    {s}
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
